'use client';

import React from "react";
import * as MainI from "./MainInterface";
import MainController from "./MainController";
import Chart from "./Chart";
import FirstPage from "./FirstPage";
import ChartPreview from "./ChartPreview";
import Greeting from "./Greeting";
import ChartHome from "./ChartHome";
import Manage from "./Manage";
import MainLayout from "./MainLayout";
import Studio from "./Studio";
import FieldSelector from "./FieldSelector";
import { ISCHART_INFORMATICS_GS } from "../informatics/config";
import { getDownloadURL, ref } from "firebase/storage";
// import { getAuth, signInWithPopup, GoogleAuthProvider, signOut, onAuthStateChanged } from 'firebase/auth';
// import { Button } from "semantic-ui-react";
// import Admin from "./Admin";
// import Greeting from "./Greeting";

export default class Me extends React.Component<any, MainI.State> {

  controller: MainController;

  constructor(props: any) {
    super(props);
    let searchParams = new URLSearchParams(globalThis?.location?.search);
    this.state = {
      ...MainI.StateInitial,
      ...(props.allDivisionRead !== undefined && { allDivisionRead: props.allDivisionRead }),
      datasetId: searchParams.get('datasetId'),
      dimList: searchParams.get('dimList')?.split(",") || [],
      filename: searchParams.get('filename'),
      agg: searchParams.get('agg'),
      selectedTab: searchParams.get('selectedTab') || "Recent",
      filter: searchParams.get('filter'),
      colorValues: searchParams.get('colorValues')?.split(",") || [],
    };
    this.controller = new MainController(
      () => { return this.state },
      (state: MainI.State, callback: any) => {
        // สลับ tab ระหว่างโหลด -> fetch ที่ค้างอยู่จะ resolve หลัง component ถูก unmount ไปแล้ว
        if (this.controller?.unmounted) return;
        this.setState(state, callback)
      },
      props.useCloud,
      props.config
    );
    // ischart host (repo นี้) = ไม่ได้ส่ง prop IHV3; ใช้ flag นี้ให้ auth handler auto-load dataset ตอน login
    this.controller.isIschart = !props.IHV3;
    this.setState = this.setState.bind(this);
    if (props.controller) {
      console.log("constructor props.controller", props.controller)
    }
  }

  updateDimensions = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  componentDidMount = async () => {
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
    this.controller.handleEvent({ message: "DidMount", params: {} });

    console.log("componentDidMount auth ", this.props.controller?.auth)
    console.log("componentDidMount loggedin ", this.props.loggedin)
    console.log("componentDidMount selectedDivision ", this.props.selectedDivision)

    if (this.props.loggedin) {
      this.setState({ loggedin: this.props.loggedin })
    }

    // Got User Login 
    if (this.props.controller?.auth?.currentUser) {
      this.controller.user = this.props.controller?.auth?.currentUser;
    } else {
      this.controller.user = undefined
    }

    /// Firebase 
    if (this.props.controller?.app) {
      this.controller.app = this.props.controller?.app
    }
    if (this.props.controller?.db) {
      this.controller.db = this.props.controller?.db
    }
    if (this.props.controller?.storage) {
      this.controller.storage = this.props.controller?.storage
    }
    if (this.props.controller?.analytics) {
      this.controller.analytics = this.props.controller?.analytics
    }

    // Call getDatasetList
    if (this.props.controller?.auth.currentUser) {
      let organization = this.props.controller.getState().userProfile?.organization
      // let email = this.props.controller.getState().userProfile?.email
      console.log("Call GetDatasetList", organization)
      this.controller.handleEvent({ message: "GetDatasetList", params: {organization, isAdmin: this.props.isAdmin} })
      this.props.controller.handleEvent({ message: "GetPermit", params: {}} )
    }

  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<MainI.State>, snapshot?: any): void {

    // console.log("componentDidUpdate auth ", this.props.controller?.auth)
    // console.log('this.props.controller?.auth.currentUser: ', this.props.controller?.auth?.currentUser);

    if (this.props.controller?.auth !== prevProps?.controller?.auth) {
      this.controller.user = this.props.controller?.auth?.currentUser;
    }

    if (this.props.controller?.app !== prevProps?.controller?.app) {
      this.controller.app = this.props.controller?.app
    }
    if (this.props.controller?.db !== prevProps?.controller?.db) {
      this.controller.db = this.props.controller?.db
    }
    if (this.props.controller?.storage !== prevProps?.controller?.storage) {
      this.controller.storage = this.props.controller?.storage
    }
    if (this.props.controller?.analytics !== prevProps?.controller?.analytics) {
      this.controller.analytics = this.props.controller?.analytics
    }

    if (this.props.selectedTab !== prevProps?.selectedTab) {
      this.setState({selectedTab: this.props.selectedTab})
    }

    if (this.props.datasetId !== prevProps?.datasetId) {
      this.setState({datasetId: this.props.datasetId})
    }

    if (this.props.setChartInfo && (this.state.chartInfo !== prevState?.chartInfo)) {
      this.props.setChartInfo?.({ 
        chartInfo: this.state.chartInfo,
        datasetId: this.state.datasetId, 
        selectedTab: this.state.selectedTab, 
        allDivisionRead: this.state.allDivisionRead})
    }

    // console.log("componentDidUpdate loggedin ", this.props.loggedin)

    if (this.props.loggedin !== prevProps.loggedin) {
      this.setState({ loggedin: this.props.loggedin })
    }

  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    this.controller.handleEvent({ message: "WillUnmount", params: {} });
  }

  toDownloadUrl = (url: string) => {
    const storageRef = ref(this.controller.storage, url);
    return getDownloadURL(storageRef);
  }
  clearSocketMessage = () => {
    this.setState({ socketMessage: null })
  }

  render() {

    console.log('Me this.state.datasetId: ', this.state.datasetId);
    console.log('Me this.state.selectedTab: ', this.state.selectedTab);

    const Charts = (this.state.datasetId || !this.state.datasetId)
      && (this.state.dimList?.length === 0 || this.state.showChart) ?
      <ChartPreview
        mobile={this.state.height && this.state.width ? this.state.height > this.state.width : false}
        width={this.state.width}
        height={this.state.height}
        onEvent={this.controller.handleEvent}
        setState={this.setState}
        datasetId={this.state.datasetId}
        chartInfo={this.state.chartInfo}
        showChart={this.state.showChart}
        filename={this.state.filename}
        agg={this.state.agg}
        selectedTab={this.state.selectedTab}
        filter={this.state.filter}
        colorValues={this.state.colorValues}
        loggedin={this.state.loggedin}
        dimList={this.state.dimList}
        duckLoaded={this.state.duckLoaded}
        useCloud={this.controller.useCloud}
        toDownloadUrl={this.toDownloadUrl}
        urlPrefix={this.controller.urlPrefix}
        informaticsGs={this.controller.config?.ISCHART_INFORMATICS_GS ?? ISCHART_INFORMATICS_GS}
        socketMessage={this.state.socketMessage}
        clearSocketMessage={this.clearSocketMessage}
        Admin={this.props.Admin}
        allDivisionRead={this.state.allDivisionRead}
        hideSelectorPanel={this.props.hideSelectorPanel}
        IHV3={this.props.IHV3}
        bindingDropdown={this.props.bindingDropdown}
        permitToken={this.state.permitToken}
        { ...(this.props.selectedDivisionIHV3 && { selectedDivisionIHV3: this.props.selectedDivisionIHV3 })}
      />

      : this.props.view === "chart" ?
        <Chart
          width={this.state.width}
          height={this.state.height}
          onEvent={this.controller.handleEvent}
          setState={this.setState}
          datasetId={this.state.datasetId}
          filename={this.state.filename}
          agg={this.state.agg}
          selectedTab={this.state.selectedTab}
          filter={this.state.filter}
          colorValues={this.state.colorValues}
          loggedin={this.state.loggedin}
          dimList={this.state.dimList}
          duckLoaded={this.state.duckLoaded}
          urlPrefix={this.controller.urlPrefix}
          allDivisionRead={this.state.allDivisionRead}
          { ...(this.props.selectedDivisionIHV3 && this.props.IHV3 && { selectedDivisionIHV3: this.props.selectedDivisionIHV3 })}
        />
        : <> </>

    return (
      <div style={{ height: "98vh" }}>
        {this.props.IHV3 ? <> {Charts} </> :
          <MainLayout
            onEvent={this.controller.handleEvent}
            setState={this.setState}
            loggedin={this.state.loggedin}
            user={this.controller.user}
          >

            {this.props.view === "firstPage" ? <FirstPage /> : null}
            {this.props.view === "manage" ? <Manage onEvent={this.controller.handleEvent} /> : null}
            {this.props.view === "studio" ?
              <Studio
                onEvent={this.controller.handleEvent}
                templateList={this.state.templateList}
              /> : null
            }
            {this.props.view === "fields" ?
              <FieldSelector
                onEvent={this.controller.handleEvent}
                duckLoaded={this.state.duckLoaded}
              /> : null}

            {   // !this.state.loggedin ?
              // <Greeting 
              //   onEvent={this.controller.handleEvent}
              //   loggedin={this.state.loggedin}
              // />
              //
              // 
            }

            {// : this.props.view === "chart" && !this.state.datasetId ?
              // <ChartHome 
              //   onEvent={this.controller.handleEvent}
              //   setState={this.setState}
              //   loggedin={this.state.loggedin}
              //   datasetList={this.state.datasetList}
              // />}
            }

            {this.props.view === "chart" ? Charts : null}

          </MainLayout>
        }

      </div>)
  }
}
